<mat-drawer-container class="drawer-container" [dir]="direction">
<div class="empty-layout">
<div class="content">


  <router-outlet></router-outlet>
  <app-loading-overlay></app-loading-overlay>

</div>
<app-configuration></app-configuration>
</div>
</mat-drawer-container>
